export default "__VITE_ASSET__BUGCJ0RY__"